import { render, staticRenderFns } from "./Space.vue?vue&type=template&id=23053b72&scoped=true"
import script from "./Space.vue?vue&type=script&lang=ts"
export * from "./Space.vue?vue&type=script&lang=ts"
import style0 from "./Space.vue?vue&type=style&index=0&id=23053b72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23053b72",
  null
  
)

export default component.exports